import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from '../_reducers/user.reducers';

const getAuthFeatureState = createFeatureSelector<UserState>('user');

export const getAllPlansLoading = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.allPlansLoading
);

export const getApplicationRolesLoading = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.rolesLoading
);


/**
 * Select userData
 */
export const getUserProfile = createSelector(
  getAuthFeatureState,
  (state: UserState) => (state ? state.profile : null)
);

/**
 * Select lastFetchedForAppKey - tracks which app the profile was fetched for
 */
export const getLastFetchedForAppKey = createSelector(
  getAuthFeatureState,
  (state: UserState) => (state ? state.lastFetchedForAppKey : null)
);

/**
 * Select operations
 */
export const getUserOperations = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.operations
);

/**
 * Select application roles
 */
export const getApplicationRoles = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.roles
);

/**
 * Select application users
 */
export const getUsers = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.users
);

/**
 * Select current plan
 */
export const getCurrentPlan = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.currentPlan
);

/**
 * Select current plan
 */
export const getDefaultPaymentMethod = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.defaultPaymentMethod
);

/**
 * Get all plans from stripe
 */
export const getAllPlans = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.allPlans
);

/**
 * Select application users
 */
export const getStriplePortalLink = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.stripePortalLink
);

/**
 * Select subscribe response
 */
export const getSubscribeResponse = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.subscribeResponse
);

/**
 * Select error
 */
export const getAuthError = createSelector(
  getAuthFeatureState,
  (state: UserState) => state.error
);
